<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-container>
            <div id='mapbox'>
            </div>
            <v-speed-dial
            v-model='fab'
            id='layerselect'
            class='layercontrol'
            transition='slide-y-reverse-transition'
            bottom
            right
            >
            <v-btn
            slot='activator'
            color='blue darken-2'
            dark
            fab
            >
            <v-icon v-if='!fab'>layers</v-icon>
            <v-icon v-if='fab'>close</v-icon>
          </v-btn>
          <v-btn
          dark
          round
          flex-start
          color='grey darken-3'
          v-for='layer in layerToggleArray'
          :key='layer.name'
          class='layerbutton'
          v-on:click.stop='toggleLayer(layer)'>
          <v-icon v-if='layer.show'>remove</v-icon>
          <v-icon v-if='!layer.show'>add</v-icon>
          <v-chip color='blue-grey lighten-5'>
            <v-avatar
            size='16px'>
              <img :src='layer.icon'>
              </img>
            </v-avatar>
            {{layer.name}}
          </v-chip>
        </v-btn>
  </v-speed-dial>
</v-container>
</v-card>
</v-flex>
</v-layout>
</v-container>
</template>
<script>
import mapboxgl from 'mapbox-gl'
import {db} from '../../firebase/firebase'
import MapboxPopup from './MapboxPopup'
import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
// mapboxgl.accessToken = 'pk.eyJ1IjoicmhhcHNibHUiLCJhIjoiY2o4bzU2OWJ2MWczcTJ3czdka3VrenRqeCJ9.YMYBvuilfxqzTM8eEHJsGg'
mapboxgl.accessToken = 'pk.eyJ1IjoibWRvbmFodWUiLCJhIjoiY2pncXp0Y3lzMGg1eDMzcDZpNzk3c21xZSJ9.O6CmD2EZ6RCK33KCmh-dEw'

// class HelloWorldControl {
//   onAdd (map) {
//     this._map = map
//     this._container = document.createElement('div')
//     this._container.className = 'mapboxgl-ctrl'
//     this._container.textContent = 'Hello, world'
//     return this._container
//   }

//   onRemove () {
//     this._container.parentNode.removeChild(this._container)
//     this._map = undefined
//   }
// }
export default {
  data () {
    return {
      map: '',
      mapReady: false,
      databaseReady: false,
      layerToggleArray: [],
      fab: false,
      longLatPopup: '',
      popup: new Vue({
        ...MapboxPopup,
        parent: this
      }).$mount()
    }
  },
  computed: {
    ...mapGetters('project', {
      icons: 'icons'
    }),
    layerList: function () {
      return this.map.getStyle().layers
    }
  },
  methods: {
    ...mapActions('project', {
      fetchIconAddress: 'fetchIconAddress'
    }),
    popupHandler: function (layerName, description, iconAddress, longLat, hasExtraInfo, extraInfo) {
      let isNewClick = (longLat !== this.longLatPopup)

      if (isNewClick) {
        this.longLatPopup = longLat
        this.popup.descriptions = []
      }

      let index = this.popup.descriptions.length
      this.popup.descriptions.splice(index + 1)
      this.$set(this.popup.descriptions, index, {'name': layerName, 'description': description, 'iconAddress': iconAddress, 'hasExtraInfo': hasExtraInfo, 'extraInfo': extraInfo})

      if (isNewClick) {
        new mapboxgl.Popup()
         .setLngLat(longLat)
         .setDOMContent(this.popup.$el)
         .addTo(this.map)
      }
    },
    toggleLayer: function (layer) {
      layer.show = !layer.show
      let vis = layer.show ? 'visible' : 'none'
      this.map.setLayoutProperty(layer.property, 'visibility', vis)
    },
    populateLayerToggles: function () {
      var that = this
      for (let layer in this.fb_layerToggles) {
        if (this.layerList.find(function (elem) {
          return elem['id'] === that.fb_layerToggles[layer]['.key']
        })) {
          that.fetchIconAddress(that.fb_layerToggles[layer]['icon'])
          let l = that.layerToggleArray.length
          that.layerToggleArray.splice(l + 1)
          that.$set(that.layerToggleArray, l, {'name': that.fb_layerToggles[layer]['name'], 'show': that.fb_layerToggles[layer]['default'], 'icon': that.icons(that.fb_layerToggles[layer]['icon']), 'property': that.fb_layerToggles[layer]['.key']})
          that.map.on('mouseenter', that.fb_layerToggles[layer]['.key'], function (e) {
            that.map.getCanvas().style.cursor = 'pointer'
          })
          this.map.setLayoutProperty(that.fb_layerToggles[layer]['.key'], 'visibility', that.fb_layerToggles[layer]['default'] ? 'visible' : 'none')
          that.map.on('click', that.fb_layerToggles[layer]['.key'], function (e) {
            let iconAddress = that.icons(that.fb_layerToggles[layer]['icon'])
            let descriptionTag = that.fb_layerToggles[layer]['description']
            let description = e.features[0].properties[descriptionTag]
            console.log(e.features[0].properties)
            let hasExtraInfo = (that.fb_layerToggles[layer]['extraInfo'] !== undefined)
            let extraInfo = []
            let layerName = that.fb_layerToggles[layer]['name']
            if (hasExtraInfo) {
              for (let extra in that.fb_layerToggles[layer]['extraInfo']) {
                let info = {}
                info['name'] = that.fb_layerToggles[layer]['extraInfo'][extra]['name']
                let tagKey = that.fb_layerToggles[layer]['extraInfo'][extra]['key']
                info['data'] = e.features[0].properties[tagKey]
                extraInfo.push(info)
              }
            }
            that.popupHandler(layerName, description, iconAddress, e.lngLat, hasExtraInfo, extraInfo)
          })
        }
      }
    }
  },
  watch: {
    mapReady: function () {
      if (this.databaseReady && this.mapReady) {
        this.populateLayerToggles()
      }
    },
    databaseReady: function () {
      if (this.databaseReady && this.mapReady) {
        this.populateLayerToggles()
      }
    }
  },
  mounted () {
    this.map = new mapboxgl.Map({
      container: 'mapbox',
      style: 'mapbox://styles/mdonahue/cjh9mi5q97y2l2rp9jdog9wch'
      // style: 'mapbox://styles/rhapsblu/cjg88xkk0091e2rngg1ylsa9c'
    })

    var that = this
    this.map.on('load', function () {
      that.mapReady = true
      that.map.addControl(new mapboxgl.FullscreenControl())
      that.map.addControl(new mapboxgl.NavigationControl())
     // that.map.addControl(new HelloWorldControl())
    })
  },
  firebase: function () {
    return {
      fb_layerToggles: {
        source: db.ref('/projects/Valencia/data/masterMap/LayerToggle'),
        asObject: false,
        readyCallback: function () {
          this.databaseReady = true
        }
      }
    }
  }
}
</script>
<style>
  #mapbox {
    width: 100%;
    height: 800px;
  }
  .layercontrol {
    bottom: 30px;
    right: 30px;
    position: absolute;
  }
  .layerbutton {
    justify-content: right;
  }
  .speed-dial {
    position: absolute;
  }

</style>


// WEBPACK FOOTER //
// src/components/map/Mapbox.vue